<template>
  <div class="">
    <Button 
      label=""
      class=""
      size="small"
      icon="pi pi-info"
      @click="openModal()"
      v-tooltip.left="`Detail`"
    />
    <Dialog v-model:visible="visible" :modal="true" class="p-fluid" header="Detail" :breakpoints="{ '960px': '80vw' }" :style="{ width: '50vw' }" @hide="visible = false">
      <div class="" style="">
        <!-- <div class="flex flex-column gap-2">
          <label for="kode_kategori">Kode Kategori</label>
          <InputText id="kode_kategori" v-model="dataAsal.kode_kategori" aria-describedby="kode_kategori-help" readonly />
        </div> -->
        <div class="flex flex-column gap-2">
          <label for="kode_pengaduan">Kode Pengaduan</label>
          <InputText id="kode_pengaduan" v-model="dataAsal.kode_pengaduan" aria-describedby="kode_pengaduan-help" readonly />
        </div>
        <div v-if="dataAsal.kode_tindakan_selanjutnya" class="flex flex-column gap-2">
          <label for="kode_tindakan_selanjutnya">Kode Selanjutnya</label>
          <InputText id="kode_tindakan_selanjutnya" v-model="dataAsal.kode_tindakan_selanjutnya" aria-describedby="kode_tindakan_selanjutnya-help" readonly />
        </div>
        <div v-if="dataAsal.kode_pengaduan_sebelumnya" class="flex flex-column gap-2 mt-2">
          <label for="kode_pengaduan_sebelumnya">Kode Sebelumnya</label>
          <InputText id="kode_pengaduan_sebelumnya" v-model="dataAsal.kode_pengaduan_sebelumnya" aria-describedby="kode_pengaduan_sebelumnya-help" readonly />
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="asal_pemohon">Asal</label>
          <InputText id="asal_pemohon" v-model="dataAsal.asal_pemohon" aria-describedby="asal_pemohon-help" readonly />
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="nama_pemohon">Nama Pemohon</label>
          <InputText id="nama_pemohon" v-model="dataAsal.nama_pemohon" aria-describedby="nama_pemohon-help" readonly />
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="no_identitas">No Identitas</label>
          <InputText id="no_identitas" v-model="dataAsal.no_identitas" aria-describedby="no_identitas-help" readonly />
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="no_hp_pemohon">No Handphone</label>
          <InputText id="no_hp_pemohon" v-model="dataAsal.no_hp_pemohon" aria-describedby="no_hp_pemohon-help" readonly />
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="nama_kategori">Kategori</label>
          <InputText id="nama_kategori" v-model="dataAsal.nama_kategori" aria-describedby="nama_kategori-help" readonly />
        </div>
        <div v-if="dataAsal.nama_fakultas" class="flex flex-column gap-2 mt-2">
          <label for="nama_fakultas">Fakultas</label>
          <InputText id="nama_fakultas" v-model="dataAsal.nama_fakultas" aria-describedby="nama_fakultas-help" readonly />
        </div>
        <div v-if="dataAsal.nama_prodi" class="flex flex-column gap-2 mt-2">
          <label for="nama_prodi">Prodi</label>
          <InputText id="nama_prodi" v-model="dataAsal.nama_prodi" aria-describedby="nama_prodi-help" readonly />
        </div>
        <div v-if="dataAsal.nama_biro" class="flex flex-column gap-2 mt-2">
          <label for="nama_biro">Biro</label>
          <InputText id="nama_biro" v-model="dataAsal.nama_biro" aria-describedby="nama_biro-help" readonly />
        </div>
        <div v-if="dataAsal.foto_identitas" class="flex flex-column gap-2 mt-2">
          <label for="username">Foto</label>
          <Image class="text-center" :src="$store.state.ipBackend + '/' + dataAsal.foto_identitas" alt="Image" width="250" preview />
        </div>
        <div v-if="dataAsal.file_laporan1 || dataAsal.file_laporan2" class="flex flex-column gap-2 mt-2">
          <label for="username">File</label>
          <div v-if="dataAsal.file_laporan1" class="p-inputgroup flex-1">
            <Button label="open" @click="openNewTab(dataAsal.file_laporan1)"/>
            <InputText id="file_laporan1" v-model="dataAsal.file_laporan1" aria-describedby="file_laporan1-help" readonly/>
          </div>
          <div v-if="dataAsal.file_laporan2" class="p-inputgroup flex-1">
            <Button label="open" @click="openNewTab(dataAsal.file_laporan2)"/>
            <InputText id="file_laporan2" v-model="dataAsal.file_laporan2" aria-describedby="file_laporan2-help" readonly/>
          </div>
        </div>
        <div class="flex flex-column gap-2 mt-2">
          <label for="username">Deskripsi</label>
          <Textarea id="username" v-model="dataAsal.deskripsi_pengaduan" aria-describedby="username-help" readonly />
        </div>
        <hr class="">
        <div v-if="data.catatan_operator" class="flex flex-column gap-2 mb-2">
          <label for="catatan_operator">Catatan Operator</label>
          <Textarea id="catatan_operator" v-model="dataAsal.catatan_operator" aria-describedby="catatan_operator-help" readonly />
        </div>
        <div v-if="data.catatan_supervisor" class="flex flex-column gap-2 mb-2">
          <label for="catatan_supervisor">Catatan Supervisor</label>
          <Textarea id="catatan_supervisor" v-model="dataAsal.catatan_supervisor" aria-describedby="catatan_supervisor-help" readonly />
        </div>
        <div v-if="data.catatan_manajer" class="flex flex-column gap-2 mb-2">
          <label for="catatan_manajer">Catatan Manager</label>
          <Textarea id="catatan_manajer" v-model="dataAsal.catatan_manajer" aria-describedby="catatan_manajer-help" readonly />
        </div>
        <div class="flex flex-column gap-2 mt-2" v-if="dataAsal.is_publish != null">
          <label for="is_publish">Publish</label>
          <div id="is_publish" class="">{{dataAsal.is_publish ? 'Ya' : 'Tidak'}}</div>
        </div>
        <div class="flex flex-column gap-2 mt-2" v-if="dataAsal.is_setuju != 0">
          <label for="is_setuju">Persetujuan</label>
          <div id="is_setuju" class="">{{dataAsal.is_setuju == 1 ? 'Setuju' : 'Tidak Setuju'}}</div>
        </div>
      </div>
    </Dialog>
  </div>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required } from '@vuelidate/validators'
export default {
  props: [ 'data' ],
  emits: [ 'refresh' ],
  components: {
  },
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
    return {
      loading: false,
      visible: false,
      dataAsal: {},
      dataForm: {
        catatan: null,
        is_publish: true,
      },
    };
  },
  computed: {
    isValid() {
      return !this.v$.dataForm.$invalid;
    },
    isDirty() {
      return this.v$.dataForm.$anyDirty;
    },
  },
  validations () {
    return {
      dataForm: {
        catatan: { required },
      }
    }
  },
  mounted() {
    // const vm = this
  },
  methods: {
    test(){
      // const vm = this
    },
    openNewTab(path){
      window.open(this.$store.state.ipBackend + '/' + path)
    },
    openModal(){
      const vm = this
      vm.visible = true
      vm.dataAsal = vm.data
      // console.log(vm.data)
      vm.dataForm = {
        catatan: null,
        is_publish: true,
      }
      vm.v$.$reset
      vm.v$.$reset();
    },
    async submit(){
      const vm = this
      vm.loading = true
      const data = {}
      switch (vm.data.status_pengaduan) {
        case 1:
          data.status_pengaduan = 2
          data.catatan_operator = vm.dataForm.catatan
          break;
        case 2:
          data.status_pengaduan = 3
          data.catatan_supervisor = vm.dataForm.catatan
          break;
        // case 3:
        //   data.status_pengaduan = 4
        //   data.catatan_manajer = vm.dataForm.catatan
        //   data.is_publish = vm.dataForm.is_publish
        //   data.date_catatan_manajer = vm.$moment()
        //   // data.date_catatan_manajer = vm.$moment().format('YYYY-MM-DD')
        //   break;
        default:
          break;
      }
      const res = await vm.$axios.post('pengaduan/update', {
        id: vm.data.pengaduan_id,
        ...data,
      })
      if(res.data.status == 200){
        vm.visible = false
        vm.$emit('refresh')
        vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Update Pengaduan', life: 3000 });
      }else{
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Update Pengaduan', life: 3000 });
      }
      vm.loading = false
    },
    async submitTolak(){
      const vm = this
      vm.loading = true
      const res = await vm.$axios.post('pengaduan/update', {
        id: vm.data.pengaduan_id,
        status_pengaduan: 0,
      })
      if(res.data.status == 200){
        vm.visible = false
        vm.$emit('refresh')
        vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Menolak Pengaduan', life: 3000 });
      }else{
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Menolak Pengaduan', life: 3000 });
      }
      vm.loading = true
    },
    async submitJawabanManager(){
      const vm = this
      vm.loading = true
      const res = await vm.$axios.post('pengaduan/jawaban_manajer', {
        ...vm.data,
        id: vm.data.pengaduan_id,
        status_pengaduan: 4,
        catatan_manajer: vm.dataForm.catatan,
        is_publish: vm.dataForm.is_publish,
        date_catatan_manajer: vm.$moment(),
      })
      if(res.data.status == 200){
        vm.visible = false
        vm.$emit('refresh')
        vm.$toast.add({ severity: 'success', summary: 'Konfirmasi', detail: 'Berhasil Membuat Jawaban Manager', life: 3000 });
      }else{
        vm.$toast.add({ severity: 'error', summary: 'Konfirmasi', detail: 'Gagal Membuat Jawaban Manager', life: 3000 });
      }
      vm.loading = true
    },
  },
};
</script>